var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-form',{ref:"form"},[_c('v-text-field',{attrs:{"label":_vm.$tc('entities.report.props.params',2),"rules":_vm.$isRequiredRule,"clearable":""},on:{"input":function($event){return _vm.$emit('input',_vm.model)}},model:{value:(_vm.model),callback:function ($$v) {_vm.model=$$v},expression:"model"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }